import useCheckoutConfirmation from "@app-contexts/public/shared/checkout/hooks/useCheckoutConfirmation";
import useDjangoWaffle from "@shared/hooks/djangoWaffle/useDjangoWaffle";
import useAuthProfileService from "@shared/modules/auth/hooks/useAuthProfileService";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Contacts from "../Contacts/Contacts.web";
import DownloadApp from "../DownloadApp/DownloadApp.web";
import OrderSummary from "../OrderSummary/OrderSummary.web";
import SMSDelivery from "../SMSDelivery/SMSDelivery.web";
import type { ConfirmationSummarySharedProps } from "./ConfirmationSummary.props";

export default function ConfirmationSummary(): JSX.Element {
  const {
    isLoggedIn,
    isConfirmationEmailEnabled,
    basket,
    invoice,
    isLoading,
    venue,
  } = useCheckoutConfirmation();

  const { FLAGS } = useDjangoWaffle();
  const { useRetrieve, useUpdate } = useAuthProfileService();
  const { data: user } = useRetrieve();
  const { mutateAsync: updateUserSMSSettings } = useUpdate();

  const handleUpdateSMSSettings = () => {
    if (user) {
      updateUserSMSSettings({
        id: user.id,
        newData: { ...user, sms_purchases: true },
      });
    }
  };

  const showSMSDelivery =
    isLoggedIn &&
    FLAGS.show_sms_input_post_purchase &&
    user &&
    user.sms_send_general &&
    !user?.sms_purchases &&
    basket?.uuid &&
    basket?.uuid2 &&
    invoice?.transaction_id;

  return (
    <Flex
      direction="column"
      gap="xl"
      p={{ base: "24px 20px 0 24px", md: "24px 40px 24px 24px" }}
    >
      <OrderSummary
        transactionId={
          !basket?.is_waitlist ? invoice?.transaction_id : basket.uuid
        }
        variant="full"
        isLoggedIn={isLoggedIn}
        isConfirmationEmailEnabled={isConfirmationEmailEnabled}
        isLoading={isLoading}
        basket={basket}
        venue={venue}
        purchaseSourcePlatform={basket?.purchase_source_platform}
      />

      {/* SMS Delivery is hidden behind the show_sms_input_post_purchase flag. */}
      {showSMSDelivery && (
        <SMSDelivery
          uuid={basket?.uuid}
          uuid2={basket?.uuid2}
          transactionId={invoice?.transaction_id}
          onUpdateSMSSettings={handleUpdateSMSSettings}
        />
      )}
      <Contacts />
      <DownloadApp />
    </Flex>
  );
}

export type ConfirmationSummaryProps = ConfirmationSummarySharedProps & {
  // Add any web specific props here.
};
